import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FaqCategory } from '../../../models/faqcategory.model';
import { FaqCategoryService } from '../../../services/faqcategory.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-faq-category-edit',
  templateUrl: './faq-category-edit.component.html',
  styleUrls: ['./faq-category-edit.component.css']
})
export class FaqCategoryEditComponent implements OnInit {
  id: number;
  loading = false;
  editMode = false;
  backUrl: string;

  subscription: Subscription;
  subscriptionResponse: Subscription;

  faqcategory: FaqCategory;
  faqCategoryForm: FormGroup;

  constructor(private faqService: FaqCategoryService, private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;
        this.backUrl = this.editMode ? '../../' : '../';

        if (this.id) {
          this.loading = true;
          this.faqService.httpGetFaq(this.id);
       
        }
      }
    );

    this.subscription = this.faqService.faqChanged.subscribe(
      (faq: FaqCategory) => {
        this.faqcategory = faq;

        if( this.editMode ){
          this.loading = false;
          this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.faqService.faqOperation.subscribe(
      (faq: FaqCategory) => {
        if ( typeof faq.ID !== 'undefined' ) {
          this.loading = true;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
  }

  private initForm(){
    this.faqCategoryForm = new FormGroup({
      'title': new FormControl('', Validators.required),
    });
  }

  private initFormEdit(){
    this.faqCategoryForm.patchValue({
    'title': this.faqcategory.title
    });
  }

  onSubmit(){
    let faqValues = this.faqCategoryForm.value;
    this.loading = true;

    if( this.editMode ){
      this.faqService.httpPutFaq(this.id, faqValues);
    } else {
      this.faqService.httpPostFaq(faqValues);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/faq-category-edit/faq-category-edit.component.ts